import styled from "styled-components";

import PreviewDisclaimer from "./PreviewDisclaimer.styled";

const ScanResultPreview = styled.div`
  ${PreviewDisclaimer} {
    margin-bottom: 24px;
  }
`;

export default ScanResultPreview;
